import { Button } from 'components/ui/buttons/Button/index.js';

import { useCookieConsentBarEffects } from './CookieConsentBar.effects.js';
import {
  CookieContainer,
  CookieText,
} from './CookieConsentBar.styles.js';

export const CookieConsentBar = () => {
  const [showConsent, handleAccept] = useCookieConsentBarEffects();

  return showConsent
    ? (
        <CookieContainer data-testid="cookie-consent-bar">
          <CookieText>This website uses cookies to improve your experience. We&apos;ll assume you&apos;re ok with this, but you can opt-out if you wish.</CookieText>
          <Button variant="outlined" color="info" onClick={handleAccept}>Accept</Button>
        </CookieContainer>
      )
    : null;
};
